export * from './fiche-info.service';
export * from './fiche-info.component';
export * from './fiche-info.module';